<template>
  <div class="w-full overflow-hidden">
    <main>
      <ContentDoc :head="false">
        <template v-slot="{ doc }">
          <ContentSeoMeta :doc="doc" />
          <NuxtLayout :doc="doc" name="page" />
        </template>
        <template #not-found>
          <PageNotFound />
        </template>
      </ContentDoc>
    </main>
  </div>
</template>

<script setup></script>

<style scoped></style>
